// extracted by mini-css-extract-plugin
export default {"header_logo":"Logo_header_logo__J+ja5","footer_logo":"Logo_footer_logo__P2uQ0","logo_text":"Logo_logo_text__DmI1v"};